/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      updateFreeShippingBar(cart);
    }
  });

  function updateFreeShippingBar(cart) {
    const shippingBar = document.querySelector('[data-free-shipping-bar]');
    if (!shippingBar) return;

    const threshold = parseInt(shippingBar.getAttribute('data-free-shipping-threshold'));
    const successText = shippingBar.getAttribute('data-free-shipping-success-text');
    const beforeSuccessText = shippingBar.getAttribute('data-free-shipping-before-success-text');
    const messageContainer = shippingBar.querySelector('[data-shipping-bar-message]');
    const progressBar = shippingBar.querySelector('[data-progress-bar-value]');

    const cartTotal = cart.total_price;
    const remainingAmount = threshold - cartTotal;
    const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);
    const progressColor = cartTotal >= threshold ? '#28a745' : '#40656E';

    if (cartTotal >= threshold) {
      messageContainer.innerHTML = `<p class="b-500">${successText}</p>`;
    } else {
      const remainingAmountFormatted = formatMoney(remainingAmount, window.theme.moneyFormat);
      const remainingAmountText = `<span>${remainingAmountFormatted}</span>`;
      const message = beforeSuccessText.replace('amount_price', remainingAmountText);
      messageContainer.innerHTML = `<p>${message}</p>`;
    }

    if (progressBar) {
      progressBar.style.setProperty('--width', `${progressPercentage}%`);
      progressBar.style.setProperty('--bg-color', progressColor);
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || window.theme.moneyFormat);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    var cart = e.detail.cart;
    if (cart) {
      updateFreeShippingBar(cart);
    }
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
